import React, {useEffect, useState, useContext} from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import $ from 'jquery';
import { Scrollbar } from 'react-scrollbars-custom';
import userlogo from "./../../../Public/img/dashboard-user.png";
import { AuthContext } from "../../../context/AuthContext";
import logo from "./../../../Public/img/logo-black.png";



const Sidebar = () =>{
    const navigate = useNavigate();
    const currenturl = useLocation();
    const {user, setUser} = useContext(AuthContext);

    const [loggedname, setLoggedName] = useState("");
    const [loggedroleid, setLoggedRoleID] = useState(0);
    const [loggedemail, setLoggedEmail] = useState("");

    const scrollstyle = {
                        height: 'auto',
                        width: '100%',
                        position: 'right',
                        size: '7px',
                        color: '#ccc',
                        wheelStep: 10,
                        touchScrollStep: 100,
                        };


    useEffect(() =>{

        //init();
		
        var $slimScrolls = $('.slimscroll');
        
        if($slimScrolls.length > 0) {
            
            var wHeight = $(window).height() - 60;
            $slimScrolls.height(wHeight);
            $('.sidebar .slimScrollDiv').height(wHeight);
            $(window).resize(function() {
                var rHeight = $(window).height() - 60;
                $slimScrolls.height(rHeight);
                $('.sidebar .slimScrollDiv').height(rHeight);
            });
        }
		

            $(document).on('mouseover', function(e) {
                e.stopPropagation();
                if ($('body').hasClass('mini-sidebar') && $('#toggle_btn').is(':visible')) {
                    var targ = $(e.target).closest('.sidebar, .header-left').length;
                    if (targ) {
                        $('body').addClass('expand-menu');
                        $('.subdrop + ul').slideDown();
                    } else {
                        $('body').removeClass('expand-menu');
                        $('.subdrop + ul').slideUp();
                    }
                    return false;
                }
            });

            if($('#btnFullscreen').length > 0) {
                document.getElementById('btnFullscreen').addEventListener('click', function() {
                    toggleFullscreen();
                });
            }
        //SlimScroll($);
        
        
        const userinfo = localStorage.getItem("userinfo");

        if(userinfo !== "" && userinfo !== null && userinfo !== undefined)
        {
            const loggeduserdata = JSON.parse(userinfo);

            setLoggedName(loggeduserdata.name);
            setLoggedRoleID(loggeduserdata.role_id);
            setLoggedEmail(loggeduserdata.email);
            //console.log('User info===='+loggeduserdata);
            //console.log('User info===='+loggeduserdata.name);
        }

    }, []);

    const toggleFullscreen = () =>{
		if (!document.fullscreenElement) 
		{
			document.documentElement.requestFullscreen();
		} 
		else 
		{
			if (document.exitFullscreen) 
			{
				document.exitFullscreen();
			}
		}
	}

    const handleSignout = () =>{
        localStorage.removeItem('cpmstoken');
        //sessionStorage.removeItem('cpmstoken');
        localStorage.removeItem('userinfo');

        setUser(null);

        navigate('/sign-in', { replace: true });
    }

    return(
        <div className="sidebar" id="sidebar">
            <div class="crm-brand">
                <img src={logo} alt="Logo" />
            </div>
			
			<div className="sidebar-inner slimscroll">
                <Scrollbar style={scrollstyle}>
                    <div id="sidebar-menu" className="sidebar-menu">
                        <ul className="crm-menu-list mt-3">
                            <li>
                                <Link to="/publisher/dashboard" className={currenturl.pathname === '/publisher/dashboard' ? 'active' : ''}>
                                    <i className="ti ti-home"></i>
                                    <span>Dashboard</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/publisher/leads" className={currenturl.pathname === '/publisher/leads' ? 'active' : ''}>
                                    <i className="ti ti-location"></i>
                                    <span>Leads</span>
                                </Link>
                            </li>

                            <li>
                                <Link to="/publisher/notifications" className={currenturl.pathname === '/publisher/notifications' ? 'active' : ''}>
                                    <i className="ti ti-bell"></i>
                                    <span>Notifications</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/publisher/lead/add" className={currenturl.pathname === '/publisher/lead/add' ? 'active' : ''}>
                                    <i className="ti ti-plus"></i>
                                    <span>Lead Add</span>
                                </Link>
                            </li>

                            <li>
                                <Link to="/publisher/edit-profile" className={currenturl.pathname === '/publisher/edit-profile' ? 'active' : ''}>
                                    <i className="ti ti-address-book"></i>
                                    <span>Profile</span>
                                </Link>
                            </li>
                        </ul>
                        <div class="crm-sidebar-bottom">
                            <div class="crm-logout-link" onClick={handleSignout}>
                                <i class="ti ti-power me-2"></i>
                                <span>Log out</span>
                            </div>
                        </div>
                    </div>
                </Scrollbar>
			</div>
		</div>
    )
}

export default Sidebar;
